import { NgModule } from "@angular/core";
import { TabletViewTabsComponent } from "./tablet-view-tabs.component";
import { ButtonModule } from "primeng/button";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        TranslateModule
    ],
    declarations: [
        TabletViewTabsComponent
    ],
    exports: [
        TabletViewTabsComponent
    ]
})
export class TabletViewTabsModule { }